import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Mail, Check } from 'lucide-react';
import { Toaster } from '@/components/ui/sonner';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

const Shell = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center p-4 font-tac-body" style={{ background: 'linear-gradient(135deg,#F4F2EE,#E6E6EA)' }}>
    <Toaster position="top-center" richColors />
    <div className="w-full" style={{ maxWidth: 440 }}>
      <div style={{ background: '#fff', borderRadius: 14, padding: '34px 32px', boxShadow: '0 18px 48px rgba(20,20,20,0.14)' }}>
        {children}
      </div>
    </div>
  </div>
);

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${BACKEND_URL}/api/auth/forgot-password`, { email: email.trim() });
      setSubmitted(true);
      toast.success('Password reset instructions sent to your email');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <Shell>
        <div className="text-center">
          <div className="flex items-center justify-center mx-auto" style={{ width: 64, height: 64, borderRadius: '50%', background: '#DCFCE7', marginBottom: 20 }}>
            <Check className="w-8 h-8" style={{ color: '#15803D' }} strokeWidth={2.4} />
          </div>
          <div className="font-tac-display" style={{ fontWeight: 800, fontSize: 23, color: '#141414', letterSpacing: '-0.01em' }}>Check your email</div>
          <div style={{ fontSize: 13.5, color: '#55555C', lineHeight: 1.6, margin: '10px 0 8px' }}>
            If an account exists with that email, you'll receive password reset instructions shortly.
          </div>
          <div style={{ fontSize: 12.5, color: '#9A9AA0', marginBottom: 24 }}>Check your spam folder if it doesn't arrive.</div>
          <button onClick={() => navigate('/login')} className="font-tac-heading" style={{ fontSize: 13, color: '#55555C', fontWeight: 600, background: 'transparent', border: 'none', cursor: 'pointer' }}>← Back to sign in</button>
        </div>
      </Shell>
    );
  }

  return (
    <Shell>
      <img src="/turbo-logo-color.png" alt="Turbo 360" style={{ height: 26, width: 'auto', display: 'block', marginBottom: 22 }} />
      <div className="font-tac-display" style={{ fontWeight: 800, fontSize: 22, color: '#141414', letterSpacing: '-0.01em' }}>Forgot your password?</div>
      <div style={{ fontSize: 13.5, color: '#55555C', lineHeight: 1.6, margin: '8px 0 22px' }}>Enter the email on your account and we'll send a reset link.</div>
      <form onSubmit={handleSubmit}>
        <div style={{ fontSize: 12.5, fontWeight: 600, color: '#55555C', marginBottom: 7 }}>Email address</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, border: '1px solid #E4E4E9', borderRadius: 9, background: '#FBFBFC', padding: '0 13px', marginBottom: 22 }}>
          <Mail className="w-4 h-4" style={{ color: '#9A9AA0' }} />
          <input type="email" placeholder="you@turbo360.com.au" value={email} onChange={(e) => setEmail(e.target.value)} required style={{ flex: 1, border: 'none', outline: 'none', background: 'transparent', fontSize: 14, color: '#141414', padding: '13px 0' }} />
        </div>
        <button type="submit" disabled={loading} className="font-tac-heading w-full text-white" style={{ background: '#BF212F', borderRadius: 9, padding: '14px 24px', fontWeight: 600, fontSize: 14, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
          {loading ? 'Sending…' : 'Send reset link'}
        </button>
        <div className="text-center" style={{ marginTop: 16 }}>
          <button type="button" onClick={() => navigate('/login')} className="font-tac-heading" style={{ fontSize: 13, color: '#55555C', fontWeight: 600, background: 'transparent', border: 'none', cursor: 'pointer' }}>← Back to sign in</button>
        </div>
      </form>
    </Shell>
  );
};

export default ForgotPasswordPage;
